import React, {useContext, useCallback, useState, useEffect} from 'react'
import BigNumber from 'bignumber.js'
import styled, {ThemeContext} from 'styled-components'
import { ButtonNewPrimary } from '../../../components/Button'
import Modal, { ModalProps } from '../../../components/bakery/Modal'
import ModalActions from '../../../components/bakery/ModalActions'
import Input from '../../../components/bakery/Input'
import SortPets, { OptionProps } from '../../Pet/components/SortPets'
import { Text } from 'rebass'
import Row from '../../../components/Row'
import Loader from '../../../components/Loader'
import useModal from '../../../hooks/bakery/useModal'
import InsufficientModal from '../../../components/nftInfo/modal/InsufficientModal'
import useYam from '../../../hooks/bakery/useYam'
import { userTokenAddress } from '../../../userType/userTokenAddress'
import useTokenBalance from '../../../hooks/bakery/useTokenBalance'
import { getBalanceNumber } from '../../../utils/bakery/formatBalance'

import useBidList from '../../../hooks/nft/useBidList'
import { BIGNUMBER_FMT } from '../../../constants/bakery'
import { userTokenDecimals } from '../../../userType/userTokenDecimals'

const ConfirmBtn = styled.div`
  width: 116px;
  margin: 0 auto;
  & > button {
    height: 32px;
    font-size: 14px;
    border-radius: 26px;
  }
`
const Button = styled(ButtonNewPrimary)`
  font-family: 'Roboto-Medium';
  height: 48px;
  padding: 0;
  /* background: ${({theme}) => theme.bsBg34};
  color: ${({theme}) => theme.white}; */
`
const MinBtn = styled.div`
  margin-right: 10px;
  padding: 0 10px 0 0;
  cursor: pointer;
  color: ${({theme}) => theme.bsText33};
  font-family: 'Roboto-Medium';
  font-size: 16px;
  border-right: 1px solid ${({theme}) => theme.bsText33};
`
const SellBtn = styled(ButtonNewPrimary)`
  font-family: 'Roboto-Regular';
  border-radius: 8px;
  cursor: pointer;
  width: 64px;
  height: 25px;
  padding: 0 10px;
  border-radius: 28px;
  font-size: 13px;
  background: ${({theme}) => theme.bsBg36};
  border: 1px solid ${({theme}) => theme.bsBorder9};
  color: ${({theme}) => theme.bsText34};
  &:hover{
    border: 1px solid ${({theme}) => theme.bsBorder9};
    background: ${({theme}) => theme.bsBg36};
    color: ${({theme}) => theme.bsText34};
  }
  &:disabled:hover{
    border: none;
    background: ${({theme}) => theme.bg3};
    color: ${({theme}) => theme.btnText1};
  }
`
const TopCard = styled.div`
  position: relative;
  top: 0;
  width: 100%;
  margin: 32px 0 14px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(214,164,133, 0.3);
`
const TipsText = styled.div`
  margin: 26px auto 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const StyledTokenAdornmentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: ${({theme}) => theme.bsText34};
`
const StyledTokenSymbol = styled.span`
  /* font-weight: 700; */
  font-family: 'Roboto-Medium';
  color: ${({ theme }) => theme.bsText33};
`
const StyledInput = styled.div`
  width: 368px;
  margin: 0 auto;
  & > div {
    height: 48px;
    margin: 0 0 16px;
    background-color: ${({theme}) => theme.bsBg37};
    & > input {
      font-family: 'Roboto-Medium';
      color: ${({theme}) => theme.bsText34};
    }
  }
`
const BiddingList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0px;
  max-height: 350px;
  overflow-y: scroll;
  img {
    width: 42px;
    height: 42px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-height: 180px;
  `}
`
const BiddingItem = styled.li`
  padding: 10px 0px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  /* border-bottom: 1px solid ${({theme}) => theme.bg3}; */
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 15px;
  `}
`
const Amount = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Roboto-Bold';
  margin-right: 10px;
  color: ${({theme}) => theme.bsText36};
  & > span {
    margin-left: 6px;
    font-size: 14px;
    font-family: 'Roboto-Regular';
    color: ${({theme}) => theme.bsText35};
  }
`
const CardTitle = styled.div`
  font-size: 20px;
  color: ${({theme}) => theme.bsText28};
  margin: 32px 0;
  font-family: 'Roboto-Bold';
  text-align: center;
`
const ListMain = styled.div`
  position: relative;
  padding-top: 20px;
`
const SortBar = styled.div`
  width: 80px;
  position: absolute;
  right: 0px;
  top: -10px;
`
const BtnRow = styled(Row)`
  margin: 0 auto;
  margin-top: 35px;
  width: 306px;
  font-size: 14px;
  justify-content: space-between;
  & > button {
    width: 145px;
    height: 32px;
    border-radius: 26px;
  }
`
const EllipsisText = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 200px;
`

interface BiddingModalProps extends ModalProps {
  isBidding: boolean
  onConfirm: (amount: string) => void
  onSellTokenTo: (onSellTokenTo: string, price?: any) => void
  tokenId: string
  type: string
  auctionPrice?: string
  name?: string
  artist? : string,
  tokenName?: string,
}

const options: OptionProps[] = [{
  sortName: 'price',
  sortBy: 'asc',
  key: 1,
  name: 'Price',
}, {
  sortName: 'price',
  sortBy: 'desc',
  key: 2,
  name: 'Price',
}]

function dealToken (address: any) {
  if (address) {
    return address.substring(0, 10) + '...' + address.substring(33, 42)
  }
  return '-'
}
function compareAsc(p:any){ //这是比较函数
  return function(m:any,n:any){
      var a = m[p];
      var b = n[p];
      return a - b; //升序
  }
}
function compareDesc(p:any){ //这是比较函数
  return function(m:any,n:any){
      var a = m[p];
      var b = n[p];
      return b - a; //降序
  }
}

const WithdrawModal: React.FC<BiddingModalProps> = ({
  isBidding,
  onConfirm,
  onDismiss,
  tokenId,
  type,
  onSellTokenTo,
  auctionPrice,
  name,
  artist,
  tokenName
}) => {
  const theme = useContext(ThemeContext)
  const [val, setVal] = useState('')
  const emptyBids: any[] = []
  const [bids, setBids] = useState(emptyBids)
  const [pendingTx, setPendingTx] = useState(false)
  const [sellingTx, setSellingTx] = useState(false)
  const [curSelect, setCurSelect] = useState(options[1])
  const [maxPrice, setMaxPrice] = useState(0)
  const [sellToken, setSellToken] = useState<any>()

  let decimals = userTokenDecimals(tokenName)
  const list = useBidList(tokenId, type, tokenName)
  
  const fetchList = useCallback(async(select) => {
    try {
      const bidList = await list()
      if (select.key === 2) {
        bidList.sort(compareDesc("curPrice"));
        setBids(bidList)
      } else {
        bidList.sort(compareAsc("curPrice"));
        setBids(bidList)
      }
      const priceList = bidList.map((item: any) => {
        return item.curPrice.toNumber()
      })
      if (!priceList.length) return
      const getMax = (priceList: any) => {
        return Math.max.apply(null, priceList)
      }
      setMaxPrice(getMax(priceList))
    } catch (e) {
      console.log(e)
    }
  }, [list])

  const getList = useCallback(async () => {
    fetchList(curSelect)
  }, [curSelect, fetchList])

  useEffect(() => {
    getList()
  }, [tokenId, getList])

  useEffect(() => {
    fetchList(curSelect)
  }, [curSelect, fetchList])

  const updateData = useCallback((d) => {
    setCurSelect(d)
  }, [])

  const confirm = useCallback(async () => {
    setSellingTx(true)
    await onSellTokenTo(sellToken.bidder, sellToken.curPrice)
    setSellingTx(false)
    onDismiss && onDismiss()
  }, [onDismiss, onSellTokenTo, sellToken])

  const [openInsufficientModal] = useModal(
    <InsufficientModal />
  )

  // token balance
  const sushi = useYam()
  const tokenAddress = userTokenAddress(sushi, tokenName)
  const [tokenBalance, setTokenBalance] = useState(0)
  const bakeryBalance = useTokenBalance(tokenAddress)
  useEffect(() => {
    const balance = getBalanceNumber(bakeryBalance, decimals)
    setTokenBalance(balance)
  }, [bakeryBalance, decimals])

  const orderBid = useCallback(async () => {
    try {
      if (tokenBalance < +val) {
        openInsufficientModal()
        return
      }
      const realPrice = new BigNumber(+val)
        .multipliedBy(
          new BigNumber(10).pow(decimals)
        ).toString()
      setPendingTx(true)
      await onConfirm(realPrice)
      setPendingTx(false)
      onDismiss && onDismiss()
    } catch (e) {
      console.log(e)
    }
  }, [onConfirm, onDismiss, val, decimals, tokenBalance, openInsufficientModal])

  const handleChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      if (auctionPrice) {
        const text: string = e.currentTarget.value.replace(/^0+/g, '').replace(/[^\d]/g, '')
        setVal(text)
      } else {
        setVal(e.currentTarget.value)
      }
    },
    [setVal, auctionPrice],
  )
  const setMinVal = useCallback(() => {
    let num
    if (bids.length > 0) {
      if (curSelect.key === 1) {
        num = bids[bids.length - 1].curPrice
      } else {
        num = bids[0].curPrice
      }
      num = auctionPrice && num.comparedTo(new BigNumber(auctionPrice)) <= 0 ? new BigNumber(auctionPrice) : num
    } else {
      num = auctionPrice ? new BigNumber(auctionPrice): new BigNumber(0)
    }
    setVal((num.plus(new BigNumber(1))).toString())
  }, [curSelect, bids, auctionPrice])

  const setMin = useCallback(() => {
    setVal((+maxPrice + 1).toString())
  }, [maxPrice])

  return (
    <>
      {
        !sellToken ?
        <Modal maxWidth={424} backgroundColor={theme.bsBg36} padding={'0 32px 17px'}>
          {
            isBidding &&
            <TopCard>
              <CardTitle style={{margin: '0'}}>Bidding</CardTitle>
              <TipsText>
                <Text fontFamily={'Roboto-Bold'} color={theme.bsText28} marginRight={'5px'}>{ name }</Text>
                <EllipsisText color={theme.bsText28}> { artist ? '—' + artist : '' }</EllipsisText>
              </TipsText>
              {
                auctionPrice ? (
                  <TipsText style={{margin: '-5px auto 5px', padding: '0', justifyContent: 'flex-start', lineHeight: '27px'}}>
                    <Text fontFamily={'Roboto-Medium'} fontWeight={600} fontSize={14} color={theme.bsText35}>Opening Price:</Text>
                    <Text marginLeft='5px' fontFamily={'Roboto-Bold'} color={theme.bsText36}>{new BigNumber(auctionPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)}</Text>
                  </TipsText>
                ) : <></>
              }
                <StyledInput>
                  <Input
                    endAdornment={(
                      <StyledTokenAdornmentWrapper>
                        {
                          auctionPrice && <MinBtn onClick={setMinVal}>Min</MinBtn>
                        }
                        { !auctionPrice && <MinBtn onClick={setMin}>Min</MinBtn> }
                        <StyledTokenSymbol>{tokenName || 'BAKE'}</StyledTokenSymbol>
                      </StyledTokenAdornmentWrapper>
                    )}
                    onChange={handleChange}
                    placeholder="0"
                    value={val}
                  />
                </StyledInput>
              <ConfirmBtn>
                {
                  !auctionPrice ? (
                    <Button
                      disabled={pendingTx || !(+val > 0) || !(+val > +maxPrice)}
                      altDisabledStyle={pendingTx || !(+val > 0) || !(+val > +maxPrice)}
                      onClick={orderBid}
                    >
                      Confirm
                    </Button>
                  ) : (
                    <Button
                      disabled={pendingTx || !(+val > 0) || new BigNumber(val).comparedTo(new BigNumber(auctionPrice)) <= 0 || (bids.length > 0 && ((curSelect.key === 1 && new BigNumber(val).comparedTo(new BigNumber(bids[bids.length - 1].curPrice)) <= 0) ||
                      (curSelect.key === 2 && new BigNumber(val).comparedTo(new BigNumber(bids[0].curPrice)) <= 0)))}
                      altDisabledStyle={pendingTx || !(+val > 0) || new BigNumber(val).comparedTo(new BigNumber(auctionPrice)) <= 0 || (bids.length > 0 && ((curSelect.key === 1 && new BigNumber(val).comparedTo(new BigNumber(bids[bids.length - 1].curPrice)) <= 0) ||
                      (curSelect.key === 2 && new BigNumber(val).comparedTo(new BigNumber(bids[0].curPrice)) <= 0)))}
                      onClick={orderBid}
                    >
                      Confirm
                    </Button>
                  )
                }
              </ConfirmBtn>
            </TopCard>
          }
          {
            !isBidding && bids.length > 0 && <CardTitle>Bidding</CardTitle>
          }
          <ListMain>
            {
              bids.length > 0 && <SortBar>
                <SortPets
                  bg={theme.bsBg30}
                  curSelect={curSelect}
                  options={options}
                  updateData={updateData}
                  height={30}
                  top="40px"
                ></SortPets>
              </SortBar>
            }
            <BiddingList>
              {
                bids.length ? (
                  bids.map((d, index) => {
                    return (
                      <BiddingItem key={d.bidder}>
                        <Text fontFamily={'Roboto-Medium'} color={theme.bsText32}>{dealToken(d.bidder)}</Text>
                        <Row style={{width: 'auto'}}>
                          <Amount>
                            {/* <img src={'/images/bakery/icon_' + (tokenName || 'BAKE').toLocaleLowerCase() + '.svg'} width={19} height={19} style={{marginRight: '5px'}} alt=""/> */}
                            { d.price }
                            <span>{tokenName || 'BAKE'}</span>
                          </Amount>
                          {
                            !isBidding && (
                              +d.curPrice === +maxPrice ?
                              <SellBtn onClick={() => {setSellToken(d)}}>sell</SellBtn> : null
                            )
                          }
                        </Row>
                      </BiddingItem>
                    )
                  })
                ): (
                  <CardTitle>No one is currently bidding here</CardTitle>
                )
              }
            </BiddingList>
          </ListMain>
          <ModalActions>
            
          </ModalActions>
        </Modal>
        :
        <Modal maxWidth={424} backgroundColor={theme.bsBg36} padding={'40px 59px 32px'}>
          <Text fontSize={14} fontFamily="Roboto-Medium" color={theme.bsText28} textAlign="center">
            {'Are you sure you want to sell this NFT for'}
          </Text>
          <Text fontSize={20} fontFamily="Roboto-Medium" color={theme.bsText32} marginTop="24px" textAlign="center">
            {sellToken ? sellToken.price : null}
            <span style={{marginLeft: '4px', fontSize: '14px', fontFamily: 'Roboto-Medium', color: theme.bsText35}}>{tokenName ? tokenName : 'BAKE'}</span>
          </Text>

          <BtnRow>
            <ButtonNewPrimary
              style={{
                background: theme.bsBg36,
                border: '1px solid ' + theme.bsBorder9,
                color: theme.bsText36
              }}
              onClick={onDismiss}
            >
              Cancel
            </ButtonNewPrimary>
            <ButtonNewPrimary disabled={sellingTx} altDisabledStyle={sellingTx} onClick={confirm}>
              { sellingTx 
              ?
                (
                  <Row>
                    Pending <Loader stroke="white" />
                  </Row>
                )
               : 'Confirm' 
              }
            </ButtonNewPrimary>
          </BtnRow>
        </Modal>
      }
    </>
    
  )
}

export default WithdrawModal
